export default __webpack_public_path__ + "static/media/search_icon.517dd765.svg";